import auth from '@api/auth'

import {
  PASSWORD_CHANGE_BEGIN,
  PASSWORD_CHANGE_CLEAR,
  PASSWORD_CHANGE_FAILURE,
  PASSWORD_CHANGE_SUCCESS,
  PASSWORD_RESET_BEGIN,
  PASSWORD_RESET_CLEAR,
  PASSWORD_RESET_FAILURE,
  PASSWORD_RESET_SUCCESS,
  PASSWORD_EMAIL_BEGIN,
  PASSWORD_EMAIL_CLEAR,
  PASSWORD_EMAIL_FAILURE,
  PASSWORD_EMAIL_SUCCESS,
} from './_types'
import getErrorMessage from '@utils/getErrorMessage'

const getDefaultState = () => {
  return {
    emailCompleted: false,
    emailError: false,
    emailLoading: false,
    changeErrorMessage: '',
    changeCompleted: false,
    changeError: false,
    changeLoading: false,
    resetCompleted: false,
    resetError: false,
    resetLoading: false,
  }
}
export const state = getDefaultState()

export const getters = {}

export const mutations = {
  [PASSWORD_CHANGE_BEGIN](state) {
    state.changeLoading = true
  },
  [PASSWORD_CHANGE_CLEAR](state) {
    state.changeCompleted = false
    state.changeError = false
    state.changeLoading = false
  },
  [PASSWORD_CHANGE_FAILURE](state, errorMessage) {
    state.changeErrorMessage = errorMessage
    state.changeError = true
    state.changeLoading = false
  },
  [PASSWORD_CHANGE_SUCCESS](state) {
    state.changeCompleted = true
    state.changeError = false
    state.changeLoading = false
  },
  [PASSWORD_RESET_BEGIN](state) {
    state.resetLoading = true
  },
  [PASSWORD_RESET_CLEAR](state) {
    state.resetCompleted = false
    state.resetError = false
    state.resetLoading = false
  },
  [PASSWORD_RESET_FAILURE](state) {
    state.resetError = true
    state.resetLoading = false
  },
  [PASSWORD_RESET_SUCCESS](state) {
    state.resetCompleted = true
    state.resetError = false
    state.resetLoading = false
  },
  [PASSWORD_EMAIL_BEGIN](state) {
    state.emailLoading = true
  },
  [PASSWORD_EMAIL_CLEAR](state) {
    state.emailCompleted = false
    state.emailError = false
    state.emailLoading = false
  },
  [PASSWORD_EMAIL_FAILURE](state) {
    state.emailError = true
    state.emailLoading = false
  },
  [PASSWORD_EMAIL_SUCCESS](state) {
    state.emailCompleted = true
    state.emailError = false
    state.emailLoading = false
  },
}

export const actions = {
  // eslint-disable-next-line
  changePassword({ commit }, { old_password, new_password1, new_password2 }) {
    commit(PASSWORD_CHANGE_BEGIN)
    return auth
      .changeAccountPassword(old_password, new_password1, new_password2)
      .then(() => commit(PASSWORD_CHANGE_SUCCESS))
      .catch((error) => {
        const errorMessage = getErrorMessage(error)
        commit(PASSWORD_CHANGE_FAILURE, errorMessage)
      })
  },
  resetPassword({ commit }, { uid, token, password1, password2 }) {
    commit(PASSWORD_RESET_BEGIN)
    return auth
      .resetAccountPassword(uid, token, password1, password2)
      .then(() => commit(PASSWORD_RESET_SUCCESS))
      .catch(() => commit(PASSWORD_RESET_FAILURE))
  },
  sendPasswordResetEmail({ commit }, { email }) {
    commit(PASSWORD_EMAIL_BEGIN)
    return auth
      .sendAccountPasswordResetEmail(email)
      .then(() => commit(PASSWORD_EMAIL_SUCCESS))
      .catch(() => commit(PASSWORD_EMAIL_FAILURE))
  },
  clearChangeStatus({ commit }) {
    commit(PASSWORD_CHANGE_CLEAR)
  },
  clearResetStatus({ commit }) {
    commit(PASSWORD_RESET_CLEAR)
  },
  clearEmailStatus({ commit }) {
    commit(PASSWORD_EMAIL_CLEAR)
  },
}
